import { render, staticRenderFns } from "./MyContent.vue?vue&type=template&id=5596b83c&scoped=true&"
import script from "./MyContent.vue?vue&type=script&lang=js&"
export * from "./MyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5596b83c",
  null
  
)

export default component.exports